import r from"react";import e from"@mui/material/Box";function p(o){return r.createElement(e,{...o})}export{p as default};
